import { Component, Prop, Vue } from "vue-property-decorator";
import { Icon } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { CommonLocale } from "@/locales/localeid";

enum ContentExposurePositionEnum {
	MoveUp,
	MoveDown
}

export interface ContentExposurePositionProps {
	isUpDisabled?: boolean;
	isDownDisabled?: boolean;
	onMoveUping?: () => void;
	onMoveDowning?: () => void;
}

@Component({
	components: {
		Icon
	}
})
export default class ContentExposurePositionAction extends Vue {
	@Prop({ default: false }) isUpDisabled!: boolean;
	@Prop({ default: false }) isDownDisabled!: boolean;
	@Prop({ default: () => {} }) onMoveUping!: () => void;
	@Prop({ default: () => {} }) onMoveDowning!: () => void;
	@Prop({ default: () => {} }) onRemoving!: () => void;

	get contentExposurePositionEnum() {
		return ContentExposurePositionEnum;
	}
	get commonLocale(): any {
		return CommonLocale;
	}
	onUp() {
		this.onMoveUping();
	}
	onDown() {
		this.onMoveDowning();
	}
	onRemove() {
		this.onRemoving();
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
